import { render, staticRenderFns } from "./ProductShareCard.vue?vue&type=template&id=bb856436&scoped=true"
import script from "./ProductShareCard.vue?vue&type=script&lang=ts"
export * from "./ProductShareCard.vue?vue&type=script&lang=ts"
import style0 from "./ProductShareCard.vue?vue&type=style&index=0&id=bb856436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb856436",
  null
  
)

export default component.exports